import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";

import { FuseSharedModule } from "@fuse/shared.module";

import { CheckinComponent } from "./checkin.component";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatOptionModule } from "@angular/material/core";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatIconModule } from "@angular/material/icon";
import { MatTableModule } from "@angular/material/table";
import { CheckinService } from "./checkin.service";
import { SnackBarService } from "app/services/snackbar.service";

const routes = [
    {
        path: "checkin",
        component: CheckinComponent,
    },
];

@NgModule({
    declarations: [CheckinComponent],
    imports: [
        RouterModule.forChild(routes),

        TranslateModule,

        FuseSharedModule,
        MatFormFieldModule,
        MatInputModule,
        MatOptionModule,
        MatSelectModule,
        MatTableModule,
        MatButtonModule,
        MatIconModule,
        MatDatepickerModule,
        MatAutocompleteModule,
    ],
    providers: [CheckinService, SnackBarService],
    exports: [CheckinComponent],
})
export class CheckinModule {}
